import {
  ADMIN_AUTH_TOKEN_SUCCESS,
  ADMIN_AUTH_TOKEN_FAILED,
  RESET_ADMIN_AUTH_TOKEN,
  LOADING_ADMIN_AUTH_TOKEN,
  NETWORK_ERROR_ADMIN_AUTH_TOKEN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADMIN_AUTH_TOKEN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case ADMIN_AUTH_TOKEN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
      };
    case ADMIN_AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_ADMIN_AUTH_TOKEN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_ADMIN_AUTH_TOKEN:
      return (state = initialState);
    default:
      return state;
  }
};
